<template>
<footer class="container mt-6">
  <div class="content">
    <div class="columns">
        <div class="column is-12 is-offset-2">
            <p class="">© The Ugandan Academy for Health and Innovation, Infectious Diseases Institute
                College of Health Sciences, Makerere University | <a href="mailto:theacademy@idi.co.ug">theacademy@idi.co.ug</a> | +256 312 211 422
                <br>
            </p>
        </div>
    </div>
  </div>
</footer>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
</style>
